export default "data:image/webp;base64,UklGRkgAAABXRUJQVlA4TDsAAAAvJ4AGAIWSNpIgDcfP56nYtbz8fkgkCOL/TyYPGYkEgSBL7BLWahv2P619s5I0ApKIf2cQkESUpMX+ZgA="